import { Assessment } from '$synapse/models';
import { Component, inject, output } from '@angular/core';
import { AssociateAssessmentToGroupDTO } from 'src/app/dtos';
import { MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';
import {
  AssessmentSelectionComponent,
  DatePickerComponent,
} from '$synapse/core';

@Component({
  selector: 'syn-group-assessment-creation-modal',
  templateUrl: './group-assessment-creation-modal.component.html',
  styleUrls: ['./group-assessment-creation-modal.component.scss'],
  imports: [SHARED_IMPORTS, AssessmentSelectionComponent, DatePickerComponent],
})
export class GroupAssessmentCreationModalComponent {
  private readonly _modalDisplay =
    inject<MatDialogRef<GroupAssessmentCreationModalComponent>>(MatDialogRef);

  readonly addAssessment = output<AssociateAssessmentToGroupDTO>();

  groupAssessmentDescription: string;
  send = false;
  enableDate = false;
  isDateInitialized = false;

  private _selectedAssessments: Assessment[] = [];
  private _expirationDate?: Date;

  submit(): void {
    if (this._selectedAssessments?.length) {
      this.send = true;
      if (this._expirationDate) {
        this._expirationDate.setDate(this._expirationDate.getDate() + 1);
      }
      const assessmentIds = this._selectedAssessments.map(
        (assessment) => assessment.id
      );
      this.addAssessment.emit({
        assessmentIds: assessmentIds,
        description: this.groupAssessmentDescription,
        expirationDate: this._expirationDate
          ? this._expirationDate.toISOString()
          : null,
      });
      this._modalDisplay.close();
    }
  }

  addNewAssessment(assessments: Assessment[]): void {
    this._selectedAssessments = assessments;
    this.enableDate = true;
  }

  onNewDate(newDate: Date) {
    this._expirationDate = newDate;
    this._checkDate();
  }

  private _checkDate() {
    this.isDateInitialized = !!this._expirationDate;
  }
}
